import { TextField } from 'components/shared/TextField/TextField';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { getBlotterPanelItemId } from 'state/blotters/blotterPanel/blotterPanel.selector';
import { getPreviewEmails } from 'state/emailService/emailService.selectors';

import { EmailServicePreviewContent } from './EmailServicePreviewContent';

export const EmailServicePreviewForm: FC = () => {
  const emails = useSelector(getPreviewEmails);
  const referenceId = useSelector(getBlotterPanelItemId);

  return (
    <>
      <div className="form-group mb-3">
        <label htmlFor="email-service-to" className="form-label">
          <FormattedMessage id="emailService.fields.to" />
        </label>
        <div className="input-group input-group-lg">
          <div className="input-icon-start">
            <i className="icon">person</i>
          </div>
          <TextField id="email-service-to" value={emails[0].toAddress} isReadOnly />
        </div>
      </div>
      {emails[0].ccAddresses.length > 0 && (
        <div className="form-group mb-3">
          <label htmlFor="email-service-cc" className="form-label">
            <FormattedMessage id="emailService.fields.cc" />
          </label>
          <div className="input-group input-group-lg">
            <div className="input-icon-start">
              <i className="icon">people</i>
            </div>
            <TextField id="email-service-cc" value={emails[0].ccAddresses.join('; ')} isReadOnly />
          </div>
        </div>
      )}
      <div className="form-group mb-3">
        <label htmlFor="email-service-subject" className="form-label">
          <FormattedMessage id="emailService.fields.subject" />
        </label>
        <div className="input-group input-group-lg">
          <TextField id="email-service-subject" value={emails[0].subject} isReadOnly />
        </div>
      </div>
      <div className="form-group mb-3">
        <label htmlFor="email-service-preview-content" className="form-label mb-1">
          <FormattedMessage id="emailService.fields.content" />
        </label>
        <EmailServicePreviewContent
          id="email-service-preview-content"
          referenceId={referenceId ?? 'unknown'}
          content={emails[0].body}
        />
      </div>
    </>
  );
};
